import * as React from 'react';
import MultiRidePanel from '../RidePlayer/MultiRidePanel';
import RidePlayerDebugPanel from '../RidePlayer/RidePlayerDebugPanel';
import Config from '../../../config';
import { IRide } from '../RidePlayer/RidePlayerService';
import RidePlayer from '../RidePlayer';

interface IPanelsLayerProps {
  googleMap: google.maps.Map | undefined;
  rides: IRide[];
}

function PanelsLayer(props: IPanelsLayerProps): JSX.Element {
  return (
    <>
      {props.rides && <MultiRidePanel rides={props.rides} />}
      {Config.Player.debug.showPositionIndex && props.rides && (
        <RidePlayerDebugPanel rides={props.rides} />
      )}
      {props.googleMap && props.rides && (
        <RidePlayer rides={props.rides} googleMap={props.googleMap} isLastRidePlayer={false} />
      )}
    </>
  );
}

export default PanelsLayer;
